import React, { ReactNode } from 'react';
import './style.scss';

interface Props {
    children: ReactNode;
    width?: string;
}

export const FloatingCard = ({ children }: Props) => {
    return <div className="floating-card">{children}</div>;
};
